import { createSelector } from 'reselect';
import { getArmyList } from '../make/unit/edit/selector/editSelector';
import { UnitOrganisationView } from './view/UnitOrganisationView';
import { UnitOrganisationPointView } from './view/UnitOrganisationPointView';
import { selectedElementsPresenter } from '@Selectors/builder/myArmyList/make/validation/selected-elements.presenter';
import { ConstraintItemType, ConstraintType, SelectedItemType } from '@Models';
import { constrainedOjectsPresenter } from '@Selectors/builder/myArmyList/make/validation/constrained-objects.presenter';

export const unitOrganisations = createSelector(
  [getArmyList, constrainedOjectsPresenter, selectedElementsPresenter],
  (armyList, elements, selectedElements): UnitOrganisationPointView => {
    if (!armyList)
      return {
        points: 0,
        organisations: [],
      };

    const categories = elements
      .filter((e) => e.type === ConstraintItemType.Organisation)
      .map((item) => {
        const selected = selectedElements.find(
          (e) =>
            e.type === SelectedItemType.ArmyListUnitOrganisation &&
            e.id === item.id,
        );

        const rate = Math.round(((selected?.points ?? 0) * 100) / armyList.max);
        const good = item.constraints.every(
          (c) =>
            (c.type === ConstraintType.Max && rate <= c.value) ||
            (c.type === ConstraintType.Min && rate >= c.value),
        );

        return {
          name: item.name,
          count: selected?.count ?? 0,
          points: selected?.points ?? 0,
          rate: Math.round(((selected?.points ?? 0) * 100) / armyList.max),
          good: good,
        } satisfies UnitOrganisationView as UnitOrganisationView;
      });

    return {
      points: armyList.points,
      organisations: categories,
    } satisfies UnitOrganisationPointView as UnitOrganisationPointView;
  },
);
